import datepicker from 'js-datepicker';
import moment from 'moment';

const datepickerSettingHelpers = {
    rangeSettings: (targetId) => {
        return targetId ? {id: targetId} : {};
    }
}

function initDatepickersForParent(parent) {
    let datepickerElements = $(parent).find('[role="datepicker"]');

    if (datepickerElements.length) {
        moment.locale(window.config.user.locale);
        const momentLocaleData = moment.localeData();
        const datepickerSettings = {
            customMonths: momentLocaleData._months,
            customDays: momentLocaleData._weekdaysShort,
            customOverlayMonths: momentLocaleData._monthsShort,
            formatter: (input, date, instance) => {
                input.value = moment(date).format(instance.el.dataset.format || 'L');
                if (input.dataset.hasOwnProperty('name') && input.closest('form')) {
                    input.closest('form').querySelector('[name=' + input.dataset.name + ']').value = moment(date).format(moment.HTML5_FMT.DATE);
                }
            },
            onSelect: (instance, date) => {
                if (instance.el.dataset.hasOwnProperty('storeRangeIn')) {
                    let range = instance.getRange();
                    if (range.start) {
                        range.start = moment(range.start).format(moment.HTML5_FMT.DATE)
                    } else {
                        range.start = '';
                    }
                    if (range.end) {
                        range.end = moment(range.end).format(moment.HTML5_FMT.DATE)
                    } else {
                        range.end = '';
                    }
                    $(instance.el.dataset.storeRangeIn).val(range.start + (instance.el.dataset.storeRangeGlue ?? '##') + range.end).trigger('change');
                }

                if (instance.el.dataset.hasOwnProperty('eventSelector')) {
                    $(instance.el.dataset.eventSelector).trigger('date-picker', {
                        // ...instance.el.dataset.hasOwnProperty('eventData') ? JSON.parse(instance.el.dataset.eventData) : {}, // TODO eventData is not a valid json string ¯\_(ツ)_/¯
                        instance,
                        date,
                        targetId: instance.el.dataset.targetId ?? null,
                        formatted: moment(date).format(moment.HTML5_FMT.DATE)
                    });
                }
            }
        };

        datepickerElements.each(function () {
            let toggleMethod = ($(this).data('toggle') || '') + 'Settings',
                settings = datepickerSettingHelpers.hasOwnProperty(toggleMethod) ? {
                    ...datepickerSettingHelpers[toggleMethod]($(this).data('targetId')),
                    ...datepickerSettings
                } : datepickerSettings;

            if (typeof window[$(this).data('name') + 'SettingsCallback'] === 'function') {
                settings = {
                    ...settings,
                    ...window[$(this).data('name') + 'SettingsCallback']()
                }
            }

            let picker = datepicker($(this).get(0), settings);

            $(this).on('change', event => {
                if (event.target.value === '') {
                    picker.setDate();
                    $('input[name="'+event.target.dataset.name+'"]').val(null);
                } else {
                    picker.setDate(moment(event.target.value, picker.el.dataset.format || 'L').toDate());
                }
            });

            // if datepicker was cleared, clear hidden input on form submit
            const form = $(this).closest('form').submit(() => {
                if (!$(this).value) {
                    document[form.name][$(this).data('name')].value = '';
                }
            });
        })
    }
}

$(document).ready(initDatepickersForParent);

export {initDatepickersForParent};
